module.exports = __webpack_public_path__ + "img/logo-chargin-white.3f13f002.svg";